var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-blocks"},[_vm._l((_vm.blocks),function(block){return _c('admin-block',{key:block.id,attrs:{"initial":block,"content":block.content,"context":block.context,"links":block.links.concat( (_vm.contentLinks ? _vm.contentLinks : []),
      (_vm.contextLinks ? _vm.contextLinks : [])
    )}})}),_c('admin-block',{attrs:{"links":_vm.blockLinks}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }